import { render, staticRenderFns } from "./edit-factory.vue?vue&type=template&id=313fe244&"
import script from "./edit-factory.vue?vue&type=script&lang=ts&"
export * from "./edit-factory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports